import config from "../config";
import { routeIcons } from "./icons";
import category from "./routes-category";

export const SCHOOL_ADMIN_ROUTES = {
  DEFAULT: "/admin",
  routes: [
    {
      category: category.teacher.ADMIN,
      path: "/admin/assessment-configuration",
      component: () =>
      import("@/features/assessment_configuration/pages/AssessmentConfigurationPage"),
      config: config.teacher,
      exact: true,
      type: "viewConfiguration",
      label: "ASSESSMENT CONFIGURATION",
      title: "Assessment Configuration",
      subtext: "View and update the assessment configuration",
      tagline: " ",
      link: "/admin/assessment-configuration",
      subdistrict: true,
      icon: () => routeIcons.assessmentConfiguration,
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin/cutline-configuration",
      component: () =>
        import("@/features/cutline_configuration/page/CutlineConfiguration"),
      config: config.teacher,
      exact: true,
      type: "customBenchmark",
      label: "CUSTOM BENCHMARK",
      title: "Custom Benchmark",
      subtext: "Enter cut lines for your district",
      tagline: "cut lines, by grade and season",
      link: "/admin/cutline-configuration",
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin/screening-window",
      component: () =>
        import("@/features/screening_window/page/ScreeningWindowPage"),
      config: config.teacher,
      exact: true,
      type: "viewConfiguration",
      label: "SCREENING WINDOWS",
      title: "Screening Windows",
      subtext: "View and update the assessment and screener tasks",
      tagline: " ",
      link: "/admin/screening-window",
      subdistrict: true,
      icon: () => routeIcons.assessmentConfiguration,
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin/curriculum-management",
      component: () =>
        import("@/features/manage_curriculum/pages/ManageCurriculumPage"),
      config: config.teacher,
      exact: true,
      type: "customBenchmark",
      label: "CURRICULUM MANAGEMENT",
      title: "Custom Benchmark",
      subtext: "Mange curriculums",
      tagline: "cut lines, by grade and season",
      link: "/admin/curriculum-management",
      subdistrict: false,
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin/school",
      component: () =>
        import("@/components/Teacher/Admin/containers/SchoolResults"), // SchoolResults,
      config: config.teacher,
      exact: true,
      type: "schoolResults",
      label: "SCHOOL-WIDE RESULTS",
      title: "School-wide Results",
      subtext: "Export school-wide test results",
      tagline: "CSV-format data on all students",
      link: "/admin/school",
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin/benchmark-assessment",
      component: () =>
        import("@/components/Teacher/Admin/containers/BenchmarkAssessment"), // BenchmarkAssessment,
      config: config.teacher,
      exact: true,
      type: "benchmarkAssessment",
      label: "ENABLE BENCHMARK ASSESSMENT",
      title: "Enable Benchmark Assessment",
      subtext: "Assign an assessment to all students in your district",
      tagline: " ",
      link: "/admin/benchmark-assessment",
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin/view-configuration",
      component: () =>
        import("@/components/Teacher/Admin/containers/ConfigurationView"), //ConfigurationView,
      config: config.teacher,
      exact: true,
      type: "viewConfiguration",
      label: "CONFIGURATION SETTINGS",
      title: "Configuration Settings",
      subtext: "View and update the assessment and screener tasks",
      tagline: " ",
      link: "/admin/view-configuration",
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin/dashboard/:itemId",
      component: () =>
        import("@/components/Teacher/Admin/containers/AdminDashboard"), //AdminDashboard,
      config: config.teacher,
      type: "adminDashboard",
      label: "ADMIN DASHBOARD",
      title: "Admin Dashboard",
      subtext: "View aggregate data for your district or school",
      tagline: " ",
      link: "/admin/dashboard/tracking",
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin/app-settings",
      component: () =>
        import("@/components/Teacher/Admin/containers/AppSettings"),
      config: config.teacher,
      exact: true,
      type: "readingConfig",
      label: "APP SETTINGS",
      title: "App Settings",
      subtext:
        "Configure the student practice experience. Select the scales and standards available in teacher reports",
      tagline: " ",
      link: "/admin/app-settings",
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin/badging-configuration",
      component: () =>
        import("@/components/Teacher/Admin/containers/BadgingConfig"), // BadgingConfig,
      config: config.teacher,
      exact: true,
      type: "badgingConfig",
      label: "BADGING CONFIGURATION",
      title: "Badging Configuration",
      subtext: "Enable or disable badging for your district or school",
      tagline: " ",
      link: "/admin/badging-configuration",
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin/assessment-classification-report",
      component: () =>
        import(
          "@/features/admin_reports/components/AssessmentClassificationReport"
        ), // AssessmentClassificationReport
      config: config.teacher,
      exact: true,
      type: "assessmentClassificationReport",
      label: "ASSESSMENT CLASSIFICATION REPORT",
      title: "Assessment Classification Report",
      subtext: "View data on assessment classification",
      tagline: " ",
      link: "/admin/assessment-classification-report",
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin/assessment-completion-report",
      component: () =>
        import(
          "@/features/admin_reports/components/AssessmentCompletionReport"
        ), // AssessmentClassificationReport
      config: config.teacher,
      exact: true,
      type: "assessmentCompletionReport",
      label: "ASSESSMENT COMPLETION REPORT",
      title: "Assessment Completion Report",
      subtext: "View data on assessment completion",
      tagline: " ",
      link: "/admin/assessment-completion-report",
      subdistrict: true,
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin/reading-risk-report",
      component: () =>
        import("@/features/admin_reports/components/ReadingRiskReport"), // AssessmentClassificationReport
      config: config.teacher,
      exact: true,
      type: "readingRiskReport",
      label: "READING RISK REPORT",
      title: "Reading Risk Report",
      subtext: "View data on reading risk",
      tagline: " ",
      link: "/admin/reading-risk-report",
      subdistrict: true,
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin/sorpa-report",
      component: () =>
        import("@/features/admin_reports/components/SORPAReport"), // AssessmentClassificationReport
      config: config.teacher,
      exact: true,
      type: "scienceOfReadingProgramAnalysisReport",
      label: "SCIENCE OF READING PROGRAM ANALYSIS REPORT",
      title: "Science Of Reading Program Analysis Report",
      subtext: "View data on science of reading program analysis",
      tagline: " ",
      link: "/admin/sorpa-report",
      subdistrict: true,
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin/usage-report",
      component: () =>
        import("@/features/admin_reports/components/UsageReport"), // AssessmentClassificationReport
      config: config.teacher,
      exact: true,
      type: "usageReport",
      label: "USAGE REPORT",
      title: "Usage Report",
      subtext: "View data on usage",
      tagline: " ",
      link: "/admin/usage-report",
      subdistrict: true,
    },
    {
      category: category.teacher.ADMIN,
      path: "/admin",
      component: () => import("@/components/Teacher/Admin/AdminPortal"), //AdminPortal,
      title: "Admin Portal",
      config: config.teacher,
      exact: true,
    },
    {
      category: category.teacher.ACTIVITIES,
      path: "/teacher/gradebook/activities",
      component: () => import("@/components/Teacher/StudentSearch"), //StudentSearch,
      title: "Activities",
      config: config.studentSearch,
    },
    {
      category: category.teacher.REPORTS,
      path: "/teacher/reports/type/:report",
      component: () => import("@/components/Reports"), //ReportingPortal,
      config: config.teacher,
      exact: true,
    },
    {
      category: category.teacher.REPORTS,
      path: "/teacher/reports",
      component: () => import("@/components/Reports"), // ReportingPortal,
      title: "Reports",
      config: config.teacher,
      exact: true,
    },
    {
      path: "/teacher/gradebook/scoring/:activityId",
      component: () => import("@/components/Teacher/CorrectionManager"), // CorrectionManager,
      config: config.teacher,
    },
    {
      //category: category.teacher.GRADEBOOK, TODO: Add the relevant Category when we have an Intent for this route
      path: "/teacher/gradebook/comprehension",
      component: () =>
        import(
          "@/components/Teacher/ComprehensionReportCard/ComprehensionReportCard"
        ), // ComprehensionReportCard,
      config: config.teacher,
    },
  ],
};

export default SCHOOL_ADMIN_ROUTES;
